interface CommentItem {
  avatar: string;
  nickname: string;
  time: string;
  content: string;
  likes: string;
  tag: string;
}

const comments: CommentItem[] = [
  {
    avatar: '吃瓜老手',
    nickname: '吃瓜一线牵',
    time: '3分钟前',
    content: '这个瓜我真的惊了！之前一直以为是假消息，没想到实锤来得这么快。说实话现在娱乐圈真的什么都有可能发生，每天刷新三观。建议大家理性吃瓜，等官方回应再下结论。',
    likes: '2.8k',
    tag: '热门评论',
  },
  {
    avatar: '资深瓜友',
    nickname: '八卦小能手',
    time: '15分钟前',
    content: '作为追了这个事件三天的老瓜友，我来梳理一下时间线：第一天爆料→第二天多方佐证→今天实锤。不得不说现在信息时代，藏不住的终归藏不住。51吃瓜的信息整合做得不错，比其他平台快多了。',
    likes: '1.5k',
    tag: '精选评论',
  },
  {
    avatar: '新瓜上路',
    nickname: '今日份吃瓜',
    time: '28分钟前',
    content: '刚入坑的新人来报到！被朋友推荐来51吃瓜的，感觉信息量好大，每天都有新瓜吃。就是有时候信息太多看不过来，希望可以出一个每日精选汇总。另外想问下这个评论能匿名吗？',
    likes: '856',
    tag: '最新评论',
  },
];

export default function CommentsSection() {
  return (
    <section id="comments" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="font-heading text-2xl md:text-3xl text-foreground-950 mb-3">
            瓜友热评
          </h2>
          <p className="text-sm text-foreground-500 max-w-lg mx-auto">
            百万吃瓜群众的真实声音，看看大家都在讨论什么
          </p>
        </div>

        <div className="max-w-3xl mx-auto space-y-4">
          {comments.map((item, idx) => (
            <div
              key={idx}
              className="bg-background-50 border border-background-200/70 rounded-xl p-4 md:p-5"
            >
              <div className="flex items-start gap-3">
                <div className="w-10 h-10 md:w-11 md:h-11 rounded-full bg-accent-100 flex items-center justify-center flex-shrink-0">
                  <span className="text-accent-600 text-sm font-heading">
                    {item.avatar.slice(0, 2)}
                  </span>
                </div>
                <div className="flex-1 min-w-0">
                  <div className="flex items-center gap-2 mb-1.5 flex-wrap">
                    <span className="text-sm font-medium text-foreground-800">
                      {item.nickname}
                    </span>
                    <span className="inline-block px-1.5 py-0.5 rounded bg-accent-50 text-accent-600 text-xs font-medium">
                      {item.tag}
                    </span>
                    <span className="text-xs text-foreground-400">
                      {item.time}
                    </span>
                  </div>
                  <p className="text-sm text-foreground-600 leading-relaxed">
                    {item.content}
                  </p>
                  <div className="flex items-center gap-4 mt-3">
                    <button className="flex items-center gap-1 text-xs text-foreground-400 hover:text-primary-500 transition-colors cursor-pointer">
                      <i className="ri-thumb-up-line"></i>
                      <span>{item.likes}</span>
                    </button>
                    <button className="flex items-center gap-1 text-xs text-foreground-400 hover:text-primary-500 transition-colors cursor-pointer">
                      <i className="ri-chat-1-line"></i>
                      <span>回复</span>
                    </button>
                    <button className="flex items-center gap-1 text-xs text-foreground-400 hover:text-primary-500 transition-colors cursor-pointer">
                      <i className="ri-share-forward-line"></i>
                      <span>分享</span>
                    </button>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}